import type { Price } from '@/root/shared-types/dto/SailPricing'

/**
 * One attribute of a price category, by code.
 *
 * Returns `unknown` on purpose: the DTO types every value as a string, while the sailing also sends
 * booleans and integers there, so the caller has to check what it got. A `set` structure yields its
 * first value — the attributes read this way carry one.
 */
export const getPriceCategoryAttribute = (priceCategory: Price['priceCategory'], code: string): unknown => {
  const structure = priceCategory.attributes?.find((entry) => entry.attribute.code === code)?.structure
  return structure?.__structure === 'set' ? structure.values[0]?.value : structure?.value?.value
}
